import { crossdockingHubSignalrConnector } from '@/warehouse/signalR/crossdockingHubSignalrConnector';
import { locationHubSignalrConnector } from '@/warehouse/signalR/locationHubSignalrConnector';
import { useEffect } from 'react';
import { useAccess } from './useAccess';
/**
 * Opens a SignalR hub connection for every section group the current user has access to.
 * A hub the user cannot reach is never connected, so its connection flag in the store stays `null`,
 * which is exactly what marks "no access" for the reconnect snackbar.
 */
export const useSignalrConnections = () => {
    const { userHasAccessTo } = useAccess();
    const hasCrossdockingAccess = userHasAccessTo({ groups: ['crossdocking'] });
    const hasStockAccess = userHasAccessTo({ groups: ['stock'] });
    useEffect(() => {
        if (!hasCrossdockingAccess)
            return;
        crossdockingHubSignalrConnector();
    }, [hasCrossdockingAccess]);
    useEffect(() => {
        if (!hasStockAccess)
            return;
        locationHubSignalrConnector();
    }, [hasStockAccess]);
};
